import {useEffect, useState} from 'react';
import {createElement} from 'react-native';
import {format} from 'date-fns';
import PropTypes from 'prop-types';

/**
 * Converts a Date object to YYYY-MM-DD string for HTML input[type="date"]
 */
const dateToInputString = date => {
  if (!date) return '';
  if (date instanceof Date && !isNaN(date.getTime())) {
    return format(date, 'yyyy-MM-dd');
  }
  // Already a string in correct format
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }
  return format(new Date(), 'yyyy-MM-dd');
};

/**
 * Converts YYYY-MM-DD string to Date object
 */
const inputStringToDate = dateString => {
  if (!dateString || !/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return null;
  }
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setHours(0, 0, 0, 0);
  return date;
};

function DatePicker({value, onChange, style}) {
  const [inputValue, setInputValue] = useState(() => dateToInputString(value));

  // Sync internal state when prop changes (e.g., form reset)
  useEffect(() => {
    setInputValue(dateToInputString(value));
  }, [value]);

  const handleInput = event => setInputValue(event.target.value);

  const handleBlur = event => {
    const selectedDateString = event.target.value;
    const dateObj = inputStringToDate(selectedDateString);
    if (dateObj) {
      onChange(dateObj);
    }
  };

  return createElement('input', {
    type: 'date',
    onInput: handleInput,
    value: inputValue,
    onBlur: handleBlur,
    style,
  });
}

DatePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
};

DatePicker.defaultProps = {
  value: null,
  style: {},
};

export default DatePicker;
